// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ledyba: PokeData = {
  "id": 165,
  "name": "ledyba",
  "height": 10,
  "weight": 108,
  "base_experience": 53,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "comet-punch",
    "tackle",
    "double-edge",
    "supersonic",
    "agility",
    "light-screen",
    "reflect",
    "swift",
    "mach-punch",
    "safeguard",
    "baton-pass",
    "silver-wind",
    "roost",
    "air-slash",
    "bug-buzz",
    "struggle-bug"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "reflect",
    "roost",
    "air-slash",
    "bug-buzz",
    "pounce",
    "sky-attack",
    "peck",
    "infest",
    "string-shot",
    "pin-missile",
    "heal-order"
  ],
  "evolution_chain": {
    "id": 84,
    "item": null,
    "species": [
      {
        "name": "ledyba",
        "order": 197,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ledian",
        "order": 198,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 165,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 55,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
